<script setup>
  import { ref, computed, onBeforeMount } from "vue";
  import { useUiStore } from "@/stores/ui";
  import { useAgentInstructionsStore } from "@/stores/agentInstructions";
import { useCompanyStore } from "@/stores/company";

  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const agentInstructionsStore = useAgentInstructionsStore();
  const companyId = useCompanyStore().companyId;

  let id = ref(null);
  let title = ref(null);
  let isSubmitted = ref(false);
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);

  const onSubmit = () => {
    isSubmitted.value = true;
    agentInstructionsStore.deleteAgentInstructions({id : id.value, companyId })
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () =>{
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalAction.value == 'delete_agent_instructions'){
      id.value = getModalInfo.value.uuid;
      title.value = getModalInfo.value.title;
    }
  });
</script>
<template>
  <DModal v-if="getModalAction === 'delete_agent_instructions'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Delete Agent Instruction </template>
    <template #body>
      <div class="delete-text">
        <span>Are you sure you want to <b>"Delete"</b> the agent instruction <b>{{ title }}</b> ?</span>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-danger add-button mr-30" >
            Delete <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  